<template>
  <lf-button
    data-cy="send-sms-button"
    class="h-10 border border-gray-200 bg-white text-primary hover:bg-gray-100"
    :disabled="!applicationIds.length"
    @click="openSmsModal"
  >
    <slot name="icon">
      <icon-base
        :icon="IconMessage"
        view-box="0 0 16 16"
        class="mr-2 h-4 w-4"
      />
    </slot>
    {{ t("COMMON.SMS") }}
  </lf-button>
  <send-deal-communication-modal
    v-if="showSmsModal"
    :deal-id="applicationIds"
    :type="CommunicationType.sms"
    @close-dialog="showSmsModal = false"
  />
</template>
<script setup lang="ts">
import { ref } from "vue";
import { useI18n } from "vue-i18n";

import { CommunicationType } from "@/enums/communicationLogs";

import SendDealCommunicationModal from "@/components/communication/SendDealCommunicationModal.vue";
import IconMessage from "@/components/icons/IconMessage.vue";
import IconBase from "@/components/ui/IconBase.vue";
import LfButton from "@/components/ui/buttons/LfButton.vue";

interface Props {
  applicationIds: string[];
}

defineProps<Props>();

const { t } = useI18n();

const showSmsModal = ref(false);

const openSmsModal = () => {
  showSmsModal.value = true;
};
</script>
